__turbopack_context__.v({
  "inverse": "ReviewsCount-module__XUGJEW__inverse",
  "reviewsCount": "ReviewsCount-module__XUGJEW__reviewsCount",
});
